import { Switch, Route } from "react-router-dom";

import HomePage from "../pages/homepage";
import CheckoutRoutes from "./checkout";
import ShopRoutes from "./shop";

const rootRoutes = () => {
  return (
    <Switch>
      <Route exact path="/" component={HomePage} />
      <Route
        path={["/checkout/:checkoutProcessPath", "/checkout"]}
        component={CheckoutRoutes}
      />
      <Route path={["/shop"]} component={ShopRoutes} />
    </Switch>
  );
};

export default rootRoutes;
